import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { Stepper, Step } from "react-form-stepper";
// import { IoClose } from "react-icons/io5";
import AddUser from "./AddUser";
import GymVisit from "./GymVisit";
import { toast } from "react-toastify";
import BmiBmr from "./BmiBmr";
import Presentation from "./Presentation";
import MembershipFollowup from "./MembershipFollowup";
import RatingFeedback from "./RatingFeedback";
import { useGetFetch } from "../../data/Queries";
import "../../styles/enquiry.css";
import userImage from "../../images/enquiry/user.png";
import {
  userGet,
  walkinEnquiryGet,
  walkinEnquiryGetKey,
} from "../../data/ApiEndpoints";
import CustomTable from "../../components/components-bootstrap/CustomTable";
import Loader from "../ui/Loader";
import PaginationModified from "../../data/PaginationModified";
import { formatDate } from "../../utils/utilityfunc";
import { ACCOUNT_TYPES, PHONE_REGEX, statusMap } from "../../data/Constants";
import HelmetWrapper from "../../HelmetWrapper";

const EnquiryFormPage = () => {
  const [userDetails, setUserDetails] = useState(null); // user who initate the add enquiry form
  const [createdUser, setCreatedUser] = useState(null);
  const [userForm, setUserForm] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [number, setNumber] = useState();
  const [leadData, setLeadData] = useState(null);

  // user get
  const [userFilter, setUserFilter] = useState({
    is_token: 1,
    mobile: "",
    limit: "0",
  });
  const {
    data: userData,
    isLoading: isLoadingUserData,
    isFetching: isFetchingUserData,
    refetch: refetchUserData,
  } = useGetFetch({
    url: userGet,
    key: userGet,
    filters: userFilter,
  });

  // user enquiry data

  const [isPage, setIsPage] = useState(0);
  const [filters, setFilters] = useState({
    user_id: "N/A",
    limit: "0",
  });
  const {
    data: enquiryData,
    isLoading: isLoadingEnq,
    isFetching: isFetchingEnq,
    refetch: refetchEnq,
  } = useGetFetch({
    filters,
    url: walkinEnquiryGet,
    isPage: isPage + 1,
    token: userDetails?.token ? userDetails?.token : undefined,
    key: walkinEnquiryGetKey,
  });

  const COLUMNS = [
    {
      dataField: "walkin_user_name",
      text: "Name",
      formatter: (data) => {
        return <span className="flex-k fs-normal-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "customer_type",
      text: "Customer Type",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k capitalise-k">
            {row?.customer_type
              ? `${row?.customer_type}`?.replaceAll("_", " ")
              : "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "mobile",
      text: "Mobile",
      formatter: (_, row) => {
        return <span className="flex-k fs-normal-k">{row?.mobile}</span>;
      },
    },
    {
      dataField: "date",
      text: "Date",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">{formatDate(row?.date)}</span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <div className="flex-k">
            <span
              className={`badge-k fs-normal-k capitalise-k ${
                statusMap[row?.status]
              }`}
            >
              {row?.status || "N/A"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "enquiry_status",
      text: "Enquiry Status",
      formatter: (_, row) => {
        return (
          <div className="flex-k">
            <span
              className={`flex-k fs-normal-k capitalise-k badge-k ${
                statusMap[row?.enquiry_status]
              }`}
            >
              {row?.enquiry_status || "N/A"}
            </span>
          </div>
        );
      },
    },
  ];

  function handleLogin() {
    try {
      const trimmedNumber = `${number}`.trim();
      if (!PHONE_REGEX.test(trimmedNumber)) {
        toast.error("Provided Phone Number is Invalid!");
      } else {
        setUserFilter({
          ...userFilter,
          mobile: `${trimmedNumber}`.trim(),
          limit: "1",
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleBack() {
    try {
      setUserDetails(null);
      setNumber(null);
      setCreatedUser(null);
      setUserForm(null);
    } catch (error) {
      console.log(error);
    }
  }

  function next() {
    try {
      setActiveStep(activeStep + 1);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      if (userData && userData?.data) {
        const data = userData?.data[0];
        if (
          userFilter?.mobile === number &&
          userData?.status &&
          userData?.data
        ) {
          setUserDetails(data);
          setFilters({
            user_id: data?.uid || "N/A",
          });
          toast.info(userData?.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [userData]);

  useEffect(() => {
    try {
      refetchUserData();
    } catch (error) {
      console.log(error);
    }
  }, [userFilter]);

  useEffect(() => {
    try {
      refetchEnq();
    } catch (error) {
      console.log(error);
    }
  }, [filters]);

  function handleClose() {
    try {
      setActiveStep(0);
      setIsModalOpen(false);
    } catch (error) {
      console.log(error);
    }
  }

  function isFormLoading() {
    try {
      if (isLoadingUserData || isFetchingUserData) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <HelmetWrapper title="WTF: Enquiry Form Management">
      <div className="contain-wrapper">
        {userDetails ? (
          <>
            <div className="grid-k my-3">
              <header className="flex-k js-between-k">
                <div className="flex-k">
                  <button
                    onClick={handleBack}
                    className="btn-k small btn-muted-k"
                  >
                    Back
                  </button>
                </div>
                {userDetails?.account_type &&
                userDetails?.account_type !== ACCOUNT_TYPES?.member ? (
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="btn-k btn-primary-k"
                  >
                    Add Enquiry
                  </button>
                ) : null}
              </header>
            </div>

            <div>
              <div className="grid-k profile-details-wrapper grid-col-3-k">
                <div className="user-profile-wrapper">
                  <img src={userImage} alt="user" />
                  <div className="flex-k js-center-k flex-col-k items-center-k text-white capitalise-k">
                    <span>{userDetails?.name}</span>
                    <span>{userDetails?.account_type}</span>
                  </div>
                </div>
                <div className="grid-span-2-k p-1 px-3">
                  <header className="profile-details-header">Details</header>
                  <div className="grid-k grid-col-2-k">
                    <div>
                      <p className="bold-text">Email: </p>
                      <p>{userDetails?.email || "N/A"}</p>
                    </div>
                    <div>
                      <p className="bold-text">Phone: </p>
                      <p>{userDetails?.mobile || "N/A"}</p>
                    </div>
                  </div>
                  <div className="grid-k grid-col-2-k">
                    <div className="flex-k gap-1-k capitalise-k">
                      <p className="bold-text">Status: </p>
                      <p>{userDetails?.status || "N/A"}</p>
                    </div>
                    <div className="flex-k gap-1-k">
                      <p className="bold-text">Gym Name: </p>
                      <p>{userDetails?.gym_name || "N/A"}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <CustomTable columns={COLUMNS} data={enquiryData?.data || []} />
                {!enquiryData?.data?.length ? (
                  <div className="flex-k js-center-k items-center-k py-5 my-5">
                    {isLoadingEnq || isFetchingEnq ? (
                      <Loader />
                    ) : (
                      <h4>No Data Available!</h4>
                    )}
                  </div>
                ) : null}
                <div className="flex-k js-end-k mb-3">
                  <PaginationModified
                    isPage={isPage}
                    pagination={enquiryData?.pagination || []}
                    onChangePage={setIsPage}
                  />
                </div>
              </div>
            </div>
          </>
        ) : null}

        {isLoadingUserData || isFetchingUserData ? (
          <div className="flex-k js-center-k items-center-k h-75vh-k">
            <Loader size={"large"} />
          </div>
        ) : !userDetails ? (
          <div className="flex-k js-center-k items-center-k h-75vh-k">
            <div className="card-k small p-3 grid-k gap-1-k">
              <div className="flex-k flex-col-k w-full-k items-start-k gap-1-k">
                <h3>User Walkins</h3>
                <label>Enter Phone Number*</label>
                <input
                  placeholder="Enter Your Phone Number.."
                  onChange={(e) => setNumber(e?.target?.value)}
                  type="text"
                  className="input-k"
                />
              </div>
              <div className="flex-k js-center-k">
                <button
                  onClick={handleLogin}
                  className="btn-k btn-primary-k large"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        ) : null}

        <ReactModal ariaHideApp={false} isOpen={isModalOpen}>
          <div className={"modal-body-k light-bg-k rounded-5 my-3"}>
            <div className="p-2 py-4">
              <header className="flex-k js-between-k">
                <h3>Add New Walkin</h3>
                <button
                  onClick={() => handleClose()}
                  className="btn-k rounded-full-k btn-muted-k small"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                  {/* <IoClose size={25} /> */}
                </button>
              </header>

              {isFormLoading() ? (
                <Loader />
              ) : (
                <div>
                  <Stepper activeStep={activeStep}>
                    <Step label="Register" />
                    <Step label="Visit Gym" />
                    <Step label="BMI / BMR" />
                    <Step label="Presentation" />
                    <Step label="Memebership/Followup" />
                    <Step label="Rating and Feedback" />
                  </Stepper>
                  {activeStep === 0 && (
                    <AddUser
                      next={next}
                      handleBack={handleBack}
                      onSubmit={setCreatedUser}
                      setUserForm={setUserForm}
                      userDetails={userDetails}
                      onclose={() => setIsModalOpen(false)}
                      onLeadChange={setLeadData}
                    />
                  )}
                  {activeStep === 1 && (
                    <GymVisit
                      token={userDetails?.token}
                      next={next}
                      userDetails={userDetails}
                    />
                  )}
                  {activeStep === 2 && (
                    <BmiBmr next={next} userDetails={userDetails} />
                  )}
                  {activeStep === 3 && (
                    <Presentation
                      token={userDetails?.token}
                      next={next}
                      userDetails={userDetails}
                    />
                  )}
                  {activeStep === 4 && (
                    <MembershipFollowup
                      userForm={userForm}
                      refetchEnq={refetchEnq}
                      userDetails={userDetails}
                      token={userDetails?.token}
                      next={next}
                    />
                  )}
                  {activeStep === 5 && (
                    <RatingFeedback
                      userForm={userForm}
                      token={userDetails?.token}
                      userDetails={userDetails}
                      onClose={() => handleClose()}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </ReactModal>
      </div>
    </HelmetWrapper>
  );
};

export default EnquiryFormPage;
